import { BilldozerService } from '../services/billdozer.service';
// import { BlobFileService } from '../services/blob-file.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { LocalStorageService } from '../services/local-storage.service';
import { NgbCarousel, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { NodejsApiService } from '../services/nodejs-api.service';
import swal from 'sweetalert2';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-checkout',
  styleUrls: ['./checkout.component.scss'],
  templateUrl: './checkout.component.html'
})

export class CheckoutComponent implements OnInit {

  private area: string;
  private entryPoint: string;
  private month: string;
  private showNavigationArrows = false;
  private showNavigationIndicators = true;
  private title = 'Checkout';
  private toPost: object;

  // input fields
  private id: number;
  private firstName: string;
  private lastName: string;
  private email: string;
  private cell: string;
  private address: string;
  private unitNum: string;
  private province: string;
  private town: string;
  private postal: string;

  public subscription: Subscription;

  @ViewChild('myCarousel') myCarousel: NgbCarousel;

  constructor(
    config: NgbCarouselConfig,
    // private compuscan: BlobFileService
    private billdozer: BilldozerService,
    private compuscan: NodejsApiService,

    public ls: LocalStorageService
  ) {
    config.interval = 0;
    config.showNavigationArrows = false;
    config.showNavigationIndicators = false;

    this.entryPoint = '/billdozer';
    this.subcribeArea();
    this.subcribeMonth();

    this.compuscan.getCreditRating().subscribe(json => {
      console.log(json);
    });
  }

  ngOnInit() {
    const body = document.getElementById('body');
    function bodyClass() {
      body.classList.add('checkout-pg');
    }
    bodyClass();
  }

  private getInputVal(event): void {
    const inputVal = event.srcElement.id;

    if (inputVal === 'idVal') {
      this.id = event.target.value;
    } else if (inputVal === 'firstNameVal') {
      this.firstName = event.target.value;
    } else if (inputVal === 'lastNameVal') {
      this.lastName = event.target.value;
    } else if (inputVal === 'emailVal') {
      this.email = event.target.value;
    } else if (inputVal === 'cellVal') {
      this.cell = event.target.value;
    } else if (inputVal === 'addressVal') {
      this.address = event.target.value;
    } else if (inputVal === 'unitNumVal') {
      this.unitNum = event.target.value;
    } else if (inputVal === 'townVal') {
      this.town = event.target.value;
    } else if (inputVal === 'postalVal') {
      this.postal = event.target.value;
    }
  }

  private firstNext(): void {
    this.myCarousel.next();
    swal.fire({
      confirmButtonText: 'Ok',
      imageAlt: 'Landmarq Road',
      imageUrl: '/assets/img/landmarq-road.svg',
      title: 'Please note!',
      text: 'Kindly confirm that all your details are correct.',
      type: 'error'
    });
  }

  private next(): void {
    const area = this.area;
    const month = this.month;

    if ( (area !== null && area !== undefined) && (month !== null && month !== undefined) ) {
      this.myCarousel.next();
    } else {
      swal.fire({
        confirmButtonText: 'Ok',
        imageAlt: 'Landmarq Road',
        imageUrl: '/assets/img/landmarq-road.svg',
        title: 'Please note!',
        text: 'Kindly make your selections first.',
        type: 'error'
      });
    }
  }

  private proceedBillDozer(): void {
    console.table([
      ['ID', this.id],
      ['First Name', this.firstName],
      ['Last Name', this.lastName],
      ['Email', this.email],
      ['Cell', this.cell],
      ['Address', this.address],
      ['Unit Number', this.unitNum],
      ['Province', this.province],
      ['Town', this.area],
      ['Postal Code', this.postal]
    ]);

    this.toPost = this.billdozer.createPostData(
      this.address,
      this.cell,
      this.town,
      this.email,
      this.id,
      this.firstName,
      this.postal,
      this.area,
      this.lastName
    );
    this.billdozer.post(this.entryPoint, this.toPost);
    this.myCarousel.next();
  }

  private prev(): void {
    console.log('**in next', this.myCarousel);
    this.myCarousel.prev();
  }

  public subcribeArea(): void {
    this.subscription = this.ls.areaListener().subscribe(area => {
      this.area = area;
   });
  }

  public subcribeMonth(): void {
    this.subscription = this.ls.monthListener().subscribe(month => {
      this.month = month;
    });
  }
}
